"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REQUEST_FAILED = void 0;
const REQUEST_FAILED = exports.REQUEST_FAILED = 'request-failed';